<template>
  <div class="questionnaire-question-grid -double-">
    <UiNumberInput
      class="questionnaire-question-grid__item"
      :height="100"
      title="Выручка"
      placeholder="Введи данные"
      :value="revenue"
      :min="1"
      :max="9"
      :differ-zero="true"
      :show-empty="false"
      :allow-minus="false"
      @input="setRevenue"
    />
    <div class="questionnaire-question__title">
      {{ additionalTitle }}
    </div>
    <UiNumberInput
      class="questionnaire-question-grid__item"
      :height="100"
      title="Чистая прибыль"
      placeholder="Введи данные"
      :value="profit"
      :min="1"
      :max="9"
      :differ-zero="true"
      :show-empty="false"
      :allow-minus="false"
      @input="setProfit"
    />
  </div>
</template>

<script>
export default {
  name: 'DoubleNumberForm',
  props: {
    revenue: {},
    profit: {},
    additionalTitle: {}
  },
  methods: {
    setRevenue(value) {
      this.$emit('input-revenue', value);
    },
    setProfit(value) {
      this.$emit('input-profit', value);
    }
  }
};
</script>

<style scoped>
.questionnaire-question__title {
  text-align: center;
}
</style>
